(function () {
  'use strict';

  if (window.__plzWaitlistBooted) return;
  window.__plzWaitlistBooted = true;

  var TARGETS = {
    hgr: 'hgr-waitlist-form',
    plzh: 'plzh-waitlist-form',
  };

  var STORAGE_KEY = 'plzWaitlistReveal';

  function resolveWaitlistTarget(href, dataset) {
    if (dataset && dataset.plzWaitlist && TARGETS[dataset.plzWaitlist]) {
      return document.getElementById(TARGETS[dataset.plzWaitlist]);
    }
    if (!href) return null;
    if (href.indexOf('plzh-waitlist-form') !== -1 || href.indexOf('plzh-waitlist') !== -1) {
      return document.getElementById('plzh-waitlist-form');
    }
    if (href.indexOf('hgr-waitlist-form') !== -1 || href.indexOf('hgr-waitlist') !== -1) {
      return document.getElementById('hgr-waitlist-form');
    }
    return null;
  }

  function parseWaitlistKey(href) {
    if (!href) return null;
    if (href.indexOf('plzh-waitlist') !== -1) return 'plzh';
    if (href.indexOf('hgr-waitlist') !== -1) return 'hgr';
    return null;
  }

  function isSamePageHref(href) {
    if (!href || href.charAt(0) === '#') return true;
    try {
      var url = new URL(href, window.location.href);
      return url.origin === window.location.origin && url.pathname === window.location.pathname;
    } catch (error) {
      return href.charAt(0) === '/';
    }
  }

  function storeWaitlistReveal(key) {
    if (!key) return;
    try {
      sessionStorage.setItem(STORAGE_KEY, key);
    } catch (error) {
      /* ignore */
    }
  }

  function focusFirstField(el) {
    if (!el) return;
    var focusTarget = el.querySelector('input:not([type="hidden"]), textarea, select, button');
    if (!focusTarget) return;
    window.setTimeout(function () {
      focusTarget.focus({ preventScroll: true });
    }, 250);
  }

  function revealForm(el) {
    if (!el) return;
    el.classList.remove('is-collapsed', 'is-loading', 'is-error');
    el.classList.add('is-open');
    el.removeAttribute('hidden');
    el.setAttribute('aria-hidden', 'false');
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    focusFirstField(el);
  }

  function isWaitlistLink(link) {
    if (!link || link.tagName !== 'A') return false;
    if (link.hasAttribute('data-plz-waitlist')) return true;
    var href = link.getAttribute('href') || '';
    return parseWaitlistKey(href) !== null || href.indexOf('waitlist') !== -1;
  }

  function handleWaitlistClick(link, event) {
    if (!isWaitlistLink(link)) return;

    var href = link.getAttribute('href') || '';
    var target = resolveWaitlistTarget(href, link.dataset);
    if (target) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      revealForm(target);
      return;
    }

    var key = parseWaitlistKey(href);
    if (key && !isSamePageHref(href)) {
      storeWaitlistReveal(key);
    }
  }

  function revealFromHash() {
    var hash = window.location.hash;
    if (!hash || hash.indexOf('waitlist') === -1) return;
    var target = resolveWaitlistTarget(hash);
    if (!target) return;
    window.setTimeout(function () {
      revealForm(target);
    }, 200);
  }

  function revealPendingWaitlist() {
    var key = null;
    try {
      key = sessionStorage.getItem(STORAGE_KEY);
    } catch (error) {
      /* ignore */
    }
    if (!key || !TARGETS[key]) return;
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      /* ignore */
    }
    var target = document.getElementById(TARGETS[key]);
    if (!target) return;
    window.setTimeout(function () {
      revealForm(target);
    }, 300);
  }

  function boot() {
    document.querySelectorAll('.plz-waitlist-form-wrap.is-collapsed').forEach(function (wrap) {
      wrap.setAttribute('aria-hidden', 'true');
    });

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-plz-waitlist], a[href*="waitlist"]');
      if (!link || !isWaitlistLink(link)) return;
      handleWaitlistClick(link, event);
    });

    window.addEventListener('hashchange', revealFromHash);
    revealPendingWaitlist();
    revealFromHash();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
